import { StateCreator } from 'zustand';
import { Middleware } from './common';
import { DashboardStoreState } from './DashboardProvider';

export interface SettingsDrawerSlice {
  isSettingsDrawerOpen: boolean;
  openSettingsDrawer: () => void;
  closeSettingsDrawer: () => void;
}

export const createSettingsDrawerSlice: StateCreator<
  SettingsDrawerSlice & DashboardStoreState,
  Middleware,
  [],
  SettingsDrawerSlice
> = (set) => ({
  isSettingsDrawerOpen: false,

  openSettingsDrawer() {
    set(
      (state) => {
        state.isSettingsDrawerOpen = true;
        state.isEditMode = true;
      },
      false,
      '[Settings] openSettingsDrawer'
    );
  },

  closeSettingsDrawer() {
    set(
      (state) => {
        state.isSettingsDrawerOpen = false;
      },
      false,
      '[Settings] closeSettingsDrawer'
    );
  },
});
